import { useTheme, useMediaQuery } from '@mui/material';

/** Padrão único para páginas do menu Clínica: lista em cards abaixo de `md`, ajustes de diálogo no `sm`. */
export function useClinicPageBreakpoints() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTabletOrDown = useMediaQuery(theme.breakpoints.down('md'));
  return { theme, isMobile, isTabletOrDown };
}

/** Padding da página + folga inferior no mobile (evita colisão com barra/navegação). */
export const clinicPageContainerSx = {
  p: { xs: 1.5, sm: 2, md: 3 },
  pb: { xs: 10, sm: 3 },
  backgroundColor: 'transparent',
  minHeight: '100vh',
};

/** Aliases para Financeiro, Estoque e outros módulos (mesmo comportamento). */
export const usePageBreakpoints = useClinicPageBreakpoints;
export const pageContainerSx = clinicPageContainerSx;
